import { render } from "./ReportSales.vue?vue&type=template&id=a1e8cff2"
import script from "./ReportSales.vue?vue&type=script&lang=js"
export * from "./ReportSales.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__